const __WEBPACK_NAMESPACE_OBJECT__ = require("@bigcommerce/memoize");